import { render } from "./DataDisplay.vue?vue&type=template&id=96b5af84&scoped=true"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"

import "./DataDisplay.vue?vue&type=style&index=0&id=96b5af84&scoped=true&lang=css"

import exportComponent from "/usr/local/share/application/bug-finder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b5af84"]])

export default __exports__